import {
  i18n,
} from '@i18n';
import {
  AxiosResponse,
  CanceledError,
} from 'axios';

export function isAxiosCanceledError<T = unknown>(error: unknown): error is CanceledError<T> {
  return error instanceof CanceledError;
}

export function getAxiosErrorMessage(response?: AxiosResponse) {
  // REST qmulus
  return response?.data?.message
    || response?.data?.details
    || response?.data?.detail
    // npm
    || response?.data?.detail?.message
    // graphql
    || response?.data?.errors?.[0]?.message
    // fallback
    || i18n.global.t('common.errorMessage.default');
}
